import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import claimproassistNew from '../../../Assets/claimproassistNew.png'
import { MapContainer, TileLayer } from 'react-leaflet';
import axios from "../../../axiosInstance.js";
import { useNavigate } from "react-router-dom"
import HomeIcon from '@mui/icons-material/Home';
import CraneDriverDetails from './CraneDriverDetails';
import RidePopUp from './RidePopUp';
import BottomNavigationVendor from '../../../Component/Vendors/BottomNavigationVendor/BottomNavigationVendor';
import CaseFirstCard from '../../../Component/Vendors/FirstAppearComponent/CaseFirstCard/CaseFirstCard';
import { useWebSocket } from '../../../context/WebSocketContext.jsx';
import logo from '../../../Assets/navbar/logo.svg'
import { MdAccountCircle } from 'react-icons/md';
import CurrentWorkingCase from './CurrentWorkingCase.jsx'
import VendorDashboard from '../../CompanyAdmin/VendorsDetails/VenderMaster/VendorDashboard.jsx';
import { Close } from '@mui/icons-material';

const CraneDriverHome = () => {
    const navigate = useNavigate()
    const { sendMessage } = useWebSocket();
    const { messages, setMessages } = useWebSocket();
    console.log('mesage on cranedriverhome', messages)
    const [isNewCase, setNewCase] = useState(false)
    const [acceptedRequest, setAcceptedRequest] = useState(() => {
        const stored = sessionStorage.getItem('acceptedRequest');
        return stored ? JSON.parse(stored) : false;
    })

    console.log('isnewcaser', isNewCase)
    const [newCasesItems, setNewCasesItems] = useState([])
    const [latestMessage, setLatestMessage] = useState(null);
    const processedIdsRef = useRef(new Set());
    console.log('newcaseseitesm', newCasesItems)
    const [totalAssignedCases, setTotalAssignedCases] = useState([]);
    const [approvedCase, setApprovedCase] = useState([])
    const [gotResponse, setGotResponse] = useState([]);
    const [getVendorData, setGetVendorData] = useState([]);
    const [driverNotAllowedCases, setDriverNotAllowedCases] = useState([]);
    const [gotDriverNotAllowedDetails, setGotDriverNotAllowedDetails] = useState(false);



    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");
    const [data, setData] = useState([]);
    console.log("data", data)

    const [todayEarning, setTodayEarning] = useState(0);
    const [last7Days, setLast7Days] = useState(0);
    const [lastMonth, setLastMonth] = useState(0);
    const [lastYear, setLastYear] = useState(0);
    const [newmessg, setnewmessge] = useState(false)
    const [deletedVehicleOrder, setDeletedVehicleOrder] = useState(null)
    const [processedIds, setProcessedIds] = useState([]);


    const [accidentVehicleCode, setAccidentVehicleCode] = useState(() => {
        return sessionStorage.getItem('accidentVehicleCode') || null;
    })

    console.log('mesage before useEffect', messages)

    useEffect(() => {

    const handleMessages = async () => {
        console.log('inside message', messages)
        if (!token || !userId) {
            navigate("/");
            return;
        }

        if (messages.length === 0) return;

        console.log('Handling messages...');
        let shouldProcess = false;

        for (const message of messages) {
            console.log("Processing message:", message);

            if (message.forPage === "crane-user-dashboard") {
                if (message.message === "cancelled-order") {
                    console.log("Handling cancelled order");
                    setDeletedVehicleOrder(message.vehicleNo);
                }

            }
        }

            setnewmessge(true);
            await fetchAssignedCases();
            await getGotResponseVehicle();
            await fetchDriverNotAllowed();

            // ✅ After processing, clear all messages
            setMessages([]);
    };

    handleMessages();
}, [messages, token, userId]);

    // useEffect(() => {
    //     const handleMessage = async () => {
    //         if (!latestMessage || processedIds.includes(latestMessage.id)) return;

    //         console.log("🔔 New WebSocket message:", latestMessage);

    //         if (latestMessage.forPage === "crane-user-dashboard") {
    //             if (latestMessage.message === "cancelled-order") {
    //                 setDeletedVehicleOrder(latestMessage.vehicleNo);
    //             }

    //             setnewmessge(true);

    //             // Refetch all necessary data
    //             await fetchAssignedCases();
    //             await getGotResponseVehicle();
    //             await fetchDriverNotAllowed();

    //             // ✅ Force re-evaluation of new cases
    //             setNewCase(true); // ✅ This ensures `CaseFirstCard` shows again
    //         }

    //         // ✅ Mark message as processed
    //         setProcessedIds((prev) => [...prev, latestMessage.id]);
    //     };

    //     handleMessage();
    // }, [latestMessage, processedIds]);

    useEffect(() => {
        if (messages.length > 0) {
            const last = messages[messages.length - 1];
            setLatestMessage(last);
        }
    }, [messages]);

    // useEffect(() => {
    //     const handleMessage = async () => {
    //         if (!latestMessage || processedIdsRef.current.has(latestMessage.id)) return;

    //         console.log("⚡ Processing WebSocket message", latestMessage);

    //         if (latestMessage.forPage === "crane-user-dashboard") {
    //             setDeletedVehicleOrder(latestMessage.vehicleNo);
    //             setnewmessge(true);
    //             await fetchAssignedCases();
    //             await getGotResponseVehicle();
    //             await fetchDriverNotAllowed();
    //             setNewCase(true);
    //         }

    //         processedIdsRef.current.add(latestMessage.id); // 🧠 instant effect
    //     };

    //     handleMessage();
    // }, [latestMessage]);




    useEffect(() => {
        sendMessage({
            type: "join",
            userId: userId,
            userType: "crane",
        });
        const updateLocation = () => {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(position => {
                    console.log("sendingLocatio", {
                        type: 'update-location-vendor',
                        userId: userId,
                        location: {
                            ltd: position.coords.latitude,
                            lng: position.coords.longitude
                        }
                    })
                    sendMessage({
                        type: 'update-location-vendor',
                        userId: userId,
                        location: {
                            ltd: position.coords.latitude,
                            lng: position.coords.longitude
                        }
                    })
                })
            }
        }

        const locationInterval = setInterval(updateLocation, 600000);
        updateLocation()

    }, [])

    useEffect(() => {
        if (token === '' || userId === '') {
            navigate('/');
        }
        console.log("hey here i am")
        fetchAssignedCases();
        fetchDriverNotAllowed();
        getGotResponseVehicle()
        getVendorWholeDetails()
        // getVendorById(userId)
    }, [token, userId]);



    useEffect(() => {
        if (data.length > 0) {
            const today = new Date();
            const startOfToday = new Date(today.getFullYear(), today.getMonth(), today.getDate());
            const startOf7DaysAgo = new Date(today);
            startOf7DaysAgo.setDate(today.getDate() - 7);
            const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
            const startOfYear = new Date(today.getFullYear(), 0, 1);

            let todayEarningSum = 0;
            let last7DaysSum = 0;
            let lastMonthSum = 0;
            let lastYearSum = 0;

            data.forEach((entry) => {
                const confirmDoneTime = new Date(entry.confirmDoneWorkingTime.replace('|', ' '));
                const charge = parseFloat(entry.charges);

                if (confirmDoneTime >= startOfToday) {
                    todayEarningSum += charge;
                }
                if (confirmDoneTime >= startOf7DaysAgo) {
                    last7DaysSum += charge;
                }
                if (confirmDoneTime >= startOfMonth) {
                    lastMonthSum += charge;
                }
                if (confirmDoneTime >= startOfYear) {
                    lastYearSum += charge;
                }
            });

            setTodayEarning(todayEarningSum);
            setLast7Days(last7DaysSum);
            setLastMonth(lastMonthSum);
            setLastYear(lastYearSum);
        }
    }, [data]);

    useEffect(() => {
        if (totalAssignedCases.length > 0) {
            console.log('totakassisdaf', totalAssignedCases)
            const filteredItems = totalAssignedCases.filter((caseItem) => caseItem?.details[0]?.firstResponseOn === null && caseItem?.details[0]?.timedOut === 0);
            console.log('filteredItems', filteredItems)
            setNewCasesItems(filteredItems);
            setNewCase(filteredItems.length > 0);
        } else {
            setNewCasesItems([]);
            setNewCase(false);
        }
    }, [totalAssignedCases])

    const fetchAssignedCases = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/assignedTasksForVendors/${userId}/${userId}`, { headers: { Authorization: `Bearer ${token}` } });
            console.log("Total assignedTasksMechanic", response.data.data);
            setTotalAssignedCases(response.data.data);
            //totalAssignedCases[i].details[0].vendorDecision != 'reject'

            response.data.data.map((item) => {
                if (item.details[0]?.customerAcceptedVendor && !item.details[0]?.vendorMoved) {
                    console.log("some inside fetchAssigneCases", item.details[0]?.customerAcceptedVendor, item.details[0]?.approvedReaching)
                    setApprovedCase([item]);
                }
            })

        } catch (error) {
            console.error("Failed to fetch assigned cases:", error);
        }
    };

    const fetchDriverNotAllowed = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/onlyConnected/${userId}/${userId}`, { headers: { Authorization: `Bearer ${token}` } });
            console.log("Total assignedTasksMechanic", response.data.data);
            setDriverNotAllowedCases(response.data.data);
            setGotDriverNotAllowedDetails(true);
        } catch (error) {
            console.error("Failed to fetch assigned cases:", error);
        }
    }
    const getGotResponseVehicle = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/getAssignedVehicleForDashboard/${userId}`);
            console.log("getAssignedVehicleForDashboard success", response.data.data);
            const filteredResponse = [];
            for (let i = 0; i < response.data.data.length; i++) {
                if (response.data.data[i].firstResponseOn != null) {
                    filteredResponse.push(response.data.data[i]);
                }
            }
            setGotResponse(filteredResponse);
        } catch (error) {
            console.error("Failed to fetch existing data", error.response || error);
            if (error.response) {
                console.log("Error data:", error.response.data);
                console.log("Error status:", error.response.status);
                console.log("Error headers:", error.response.headers);
            } else {
                console.log("Error message:", error.message);
            }
        }
    };
    const getVendorWholeDetails = async () => {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/getDriverWholeDetails/${userId}`, { headers: { Authorization: `Bearer ${token}` } });
        setData(response.data.data);
    };
    const getVendorById = async (userId) => {
        try {
            console.log("yeser")
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/getVendorDriver/${userId}`, { headers: { 'Authorization': `Bearer ${token}` } });
            console.log("caseFirstCardhser", response.data.data)
            setGetVendorData(response.data.data);
        } catch (error) {
            console.error("Error fetching all accident vehicle data", error);
        }
    };

    const handleBack = (accepted, accidentVehicleCode) => {
        if (accepted == false) {
            console.log('not accepted', accepted)

            getGotResponseVehicle()
            fetchAssignedCases()
            fetchDriverNotAllowed();
            setNewCase(false)
        }
        else {
            console.log('accepted', accepted)
            getGotResponseVehicle()
            fetchAssignedCases()
            fetchDriverNotAllowed();
            setNewCase(false)
            setAcceptedRequest(accepted);
            setAccidentVehicleCode(accidentVehicleCode)
            console.log('acceptedrequest', accepted, accidentVehicleCode)
            sessionStorage.setItem('acceptedRequest', JSON.stringify(accepted));
            sessionStorage.setItem('accidentVehicleCode', accidentVehicleCode);
        }
    }


    return (
            <div className="h-screen w-screen overflow-x-hidden relative">
            <div className="absolute top-0 left-0 w-full h-[14.333333%] bg-gradient-to-b from-[#38bdff] to-transparent z-0"></div>
            <div style={{ zIndex: "999" }} className='bg-white fixed p-2 top-0 flex items-center justify-between w-screen'>
                <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/logo-navbar-compressed.png' alt="logo" className="h-[3rem] w-[3rem] bg-[#ffffffc4] rounded-full p-1" />
                <Link className=' h-10 w-10 bg-white flex items-center justify-center rounded-full'>
                    <Link to="/state-selector">
                        <MdAccountCircle className="text-3xl text-gray-700 hover:text-[#21a6e9] transition duration-200" />
                    </Link>
                </Link>
            </div>
                <VendorDashboard />

            <div className='fixed w-full z-10 bottom-0 translate-y-full bg-white px-3 py-10 pt-12'>
                <RidePopUp />
            </div>
            {deletedVehicleOrder && (
                <div
                    className="font-satoshi fixed  inset-0 z-[999] bg-black/40 flex px-4 items-top justify-center"
                >
                    <div className="relative w-full h-[8rem] max-w-md bg-white text-gray-800 rounded-2xl shadow-2xl pt-2 mt-3 p-2 border border-gray-200 animate-fadeIn">
                        <button
                            onClick={() => setDeletedVehicleOrder(null)}
                            className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 transition"
                        >
                            <Close size={20} />
                        </button>

                        <div className="flex gap-2 items-center text-center space-y-3">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-10 w-10 text-red-500"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                strokeWidth="2"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M9 13h6m2 6H7a2 2 0 01-2-2V7a2 2 0 012-2h4l2-2h2l2 2h4a2 2 0 012 2v10a2 2 0 01-2 2z"
                                />
                            </svg>

                            <h2 className="text-lg font-semibold text-red-600">Order Deleted</h2>
                        </div>
                        <p className="text-sm text-gray-600">
                            The order of vehicle number <strong>{deletedVehicleOrder}</strong> has been removed.
                        </p>
                    </div>
                </div>

            )}


            {isNewCase && gotDriverNotAllowedDetails && (
                <div >
                    <CaseFirstCard data={newCasesItems} pendingCasesLength={driverNotAllowedCases?.length} getBackPage={handleBack} />
                </div>
            )}
            {driverNotAllowedCases.length > 0 && (
                <CurrentWorkingCase incomingData={driverNotAllowedCases} />
            )}


        </div>
    );
};

export default CraneDriverHome;